import styled from "@emotion/styled";
import { css } from "@emotion/react";
export const Wrapper = styled.div `
  cursor: pointer;
  padding-inline: ${({ selected }) => (selected ? "11px 15px" : "12px 16px")};
  padding-block: ${({ selected }) => (selected ? "13px" : "14px")};
  background-color: ${({ theme }) => theme.colors.light[10]};
  border: ${({ theme, isDisabled, selected }) => `${selected ? 2 : 1}px solid ${isDisabled
    ? theme.colors.light[30]
    : selected
        ? theme.colors.primary[40]
        : theme.colors.light[50]}`};
  display: flex;
  ${({ grow }) => (grow ? `flex-grow: ${grow};` : "")}
  align-items: center;
  direction: rtl;
  border-radius: 15px;
  user-select: none;
  ${({ theme, isDisabled }) => isDisabled &&
    css `
      cursor: not-allowed;

      .selectable-field-name {
        color: ${theme.colors.light[30]};
      }

      img {
        opacity: 0.5;
      }

      .selectable-circle {
        border: 2px solid ${theme.colors.light[30]} !important;
      }
    `}
`;
export const CardWrapper = styled(Wrapper) `
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.light.on_primary};
`;
export const IconContainer = styled.div `
  border-radius: 50%;
  width: 2.4rem;
  height: 2.4rem;
  margin-inline-end: 0.8rem;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
  }
`;
export const SelectableCircle = styled.div `
  width: 20px;
  height: 20px;
  border: 2px solid ${({ theme }) => theme.colors.dark[300]};
  border-radius: 50%;
  position: relative;
`;
//# sourceMappingURL=SelectableField.style.js.map